<div #carousel class="carousel-wrapper">
<ngx-hm-carousel
  [(ngModel)]="currentIndex"
  show-num="1"
  [breakpoint]="breakpoints"
  [autoplay-speed]="speed"
  [infinite]="infinite"
  [drag-many]="true"
  [aniTime]="200"
  [data]="mediaContent"
  class="carousel c-accent">

  <section ngx-hm-carousel-container class="content">
    <article class="item cursor-pointer"
             ngx-hm-carousel-item
             *ngFor="let item of mediaContent; let i = index"
             [ngClass]="{'visible': currentIndex===i}">
      <ng-template [ngIf]="isImage(item.url)">
        <div class="img" [ngClass]="{'scaled': currentIndex!==i}">
          <img loading="lazy" [src]="item.url" alt="image">
          <div class="media-description">{{item.description[currentLanguage]}}</div>
        </div>
      </ng-template>
      <ng-template [ngIf]="isYoutubeVideo(item.url)">
        <div class="iframe" [ngClass]="{'scaled': currentIndex!==i}">
          <iframe
            height="auto"
            frameborder="0"
            [src]='item.url | safeurl'
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>

        </div>
      </ng-template>
      <ng-template [ngIf]="isVideo(item.url)">
        <div class="video" [ngClass]="{'scaled': currentIndex!==i}">
          <video #video (click)="pauseVideo(video)">
            <source [src]="item.url">
          </video>
          <button (click)="playVideo(video)" *ngIf="isPaused(video)"><img loading="lazy" src="/assets/icons/play.svg" alt="play"></button>
        </div>
      </ng-template>
    </article>
    <ng-template #infiniteContainer></ng-template>
  </section>

</ngx-hm-carousel>
</div>

<ng-container *ngIf="showArrowsIfOneElement && mediaContent.length > 1">
  <div class="click-area left" (click)="previousSlide()"
       [ngClass]="{width15percent: carousel.offsetWidth < 1140, width10percent: carousel.offsetWidth < 768}">
    <img loading="lazy" class="prev" src="/assets/icons/arrow-in-circle-white.svg" alt="prev">
  </div>

  <div class="click-area right" (click)="nextSlide()"
       [ngClass]="{width15percent: carousel.offsetWidth < 1140, width10percent: carousel.offsetWidth < 768}">
    <img loading="lazy" class="next" src="/assets/icons/arrow-in-circle-white.svg" alt="next">
  </div>
</ng-container>
